import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { SRoot, SInputRoot, SText, SInfo } from './CheckWithLabelBase.styled';
import { FormFieldContextProvider, useInputPropsMergedWithFormFieldContext, } from '../../../FormField/FormFieldContext/FormFieldContext';
import { extractPropsForInputComponent } from '../../../internal/extract-props/extractPropsForInputComponent';
import { useControlledCheck } from '../utils/useControlledCheck';
export var CheckWithLabelBase = forwardRef(function (incomingProps, ref) {
    var props = useInputPropsMergedWithFormFieldContext(incomingProps);
    var _a = extractPropsForInputComponent(props), rootElementAttributes = _a.rootElementAttributes, baseInputComponentProps = _a.baseInputComponentProps, baseHtmlInputAttributes = _a.baseHtmlInputAttributes, ariaAttributes = _a.ariaAttributes, dataAttributes = _a.dataAttributes, restProps = _a.restProps;
    var 
    // specifics
    label = restProps.label, info = restProps.info, CheckComponent = restProps.CheckComponent, 
    // html input attrs that we need to use and not blindly pass
    onChangeProp = restProps.onChange, checkedProp = restProps.checked, defaultCheckedProp = restProps.defaultChecked, restInputProps = __rest(restProps, ["label", "info", "CheckComponent", "onChange", "checked", "defaultChecked"]);
    var size = baseInputComponentProps.size;
    var disabled = baseHtmlInputAttributes.disabled;
    var _b = useControlledCheck({
        controlledChecked: checkedProp,
        defaultChecked: !!defaultCheckedProp,
        componentName: 'CheckWithLabelBase',
        changeHandler: onChangeProp,
    }), checked = _b.checked, changeHandler = _b.changeHandler;
    return (React.createElement(FormFieldContextProvider, { value: undefined },
        React.createElement(SRoot, __assign({}, dataAttributes, rootElementAttributes, { ref: ref, tabIndex: -1, "$size": size, "$disabled": disabled }),
            React.createElement(SInputRoot, null,
                React.createElement(CheckComponent, __assign({}, baseInputComponentProps, ariaAttributes, baseHtmlInputAttributes, restInputProps, { onChange: changeHandler, checked: checked }))),
            label && (React.createElement(SText, null,
                label,
                info && React.createElement(SInfo, null,
                    "(",
                    info,
                    ")"))))));
});
//# sourceMappingURL=CheckWithLabelBase.js.map